import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CreateNotification } from "../../../../../components/notifier";
import { documentTagsService } from "../../../../../services/document/document-tags.service";

export const useDeleteDocumentTag = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (id: string) => {
      return documentTagsService.delete(id);
    },
  });

  const deleteDocumentTag = (
    vars: any,
    options?: { successText?: string; errorText?: string; onSuccess?: (res: any) => void; onError?: () => void },
  ) => {
    mutation.mutate(vars, {
      onSuccess(response: any) {
        queryClient.invalidateQueries({ queryKey: ["document-tags"] });
        CreateNotification({ title: "Thành công", body: "Xoá chủ đề thành công", icon: "/icons/success.png" });

        if (options?.onSuccess) {
          options.onSuccess(response);
        }
      },
      onError() {
        CreateNotification({ title: "Thất bại", body: "Xoá chủ đề thất bại", icon: "/icons/warning.png" });

        if (options?.onError) {
          options.onError();
        }
      },
    });
  };
  return { deleteDocumentTag, ...mutation };
};
